import { useEffect, useState } from 'react';

import { useDispatch } from 'react-redux';

import { Box, Button, Checkbox, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, FormControl, FormControlLabel, FormLabel, Grid, IconButton, InputBase, InputLabel, MenuItem, Paper, Radio, RadioGroup, Select, Table, TableBody, TableCell, TableContainer, TableFooter, TableHead, TablePagination, TablePaginationActions, TableRow, Tooltip, Typography } from '@mui/material';

import CheckIcon from '@mui/icons-material/Check';
import DeleteIcon from '@mui/icons-material/Delete';
import DescriptionIcon from '@mui/icons-material/Description';
import EditIcon from '@mui/icons-material/Edit';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import SearchIcon from '@mui/icons-material/Search';

import { usePages } from '../../../hooks/usePages';

import { openSnackbar } from '../../../store/slices/SnackbarSlice';

import { InputSearchButtonsStyle, InputSearchStyle } from '../../../styles/FormStyle';
import { TablePaddingStyle, TableTheadStyle } from '../../../styles/TableStyle';

import { DialogBuscarPersona } from '../../../dialogs/DialogBuscarPersona';
import { DialogDocumento } from '../../../dialogs/DialogDocumento';
import { DialogNuevaPersona } from '../../../dialogs/DialogNuevaPersona';

import { GuardarAsistentes } from '../../../connections/audiencias/AudienciaConnection';
import { ObtenerTipoIdentificacion } from '../../../connections/catalogos/TipoIdentificacionConnection';
import { ObtenerTipoParte } from '../../../connections/catalogos/TipoParteConnection';

import { AsistenteProps, AudienciaProps, defaultAsistente } from '../../../interfaces/audiencias/AudienciaInterface';
import { TipoIdentificacionProps } from '../../../interfaces/catalogos/TipoIdentificacionInterface';
import { TipoParteProps } from '../../../interfaces/catalogos/TipoParteInterface';
import { defaultPersonaBusqueda, PersonaBusquedaProps } from '../../../interfaces/comun/PersonaInterface';
import { defaultParte, ParteProps } from '../../../interfaces/recepcion/ParteInterface';

type TipoParteAgregarType = '' | 'Actor/Demandado' | 'Otro';

interface Props {
    audiencia:              AudienciaProps;
    partes:                 ParteProps[];
    asistentes:             AsistenteProps[];
    edit?:                  boolean;
    setAsistentes?:         React.Dispatch<React.SetStateAction<AsistenteProps[]>>;
}

export const Asistentes = ({ audiencia, partes, asistentes, edit = true, setAsistentes }: Props) => {

    const dispatch = useDispatch( )

    const [openEditar, setOpenEditar] = useState( false );
    const [openEliminar, setOpenEliminar] = useState( false );

    const [openDialogNuevaPersona, setOpenDialogNuevaPersona] = useState( false );
    const [openDialogBuscarPersona, setOpenDialogBuscarPersona] = useState( false );

    const [loading, setLoading] = useState( false );

    const [tipoParteAgregar, setTipoParteAgregar] = useState<TipoParteAgregarType>( 'Actor/Demandado' );

    const [personaBusqueda, setPersonaBusqueda] = useState<PersonaBusquedaProps>( defaultPersonaBusqueda );

    const [parte, setParte] = useState( 0 );

    const [tipoIdentificacion, setTipoIdentifiacion] = useState( 0 );
    const [tipoIdentificacionArray, setTipoIdentifiacionArray] = useState<TipoIdentificacionProps[]>( [] );

    const [tipoIdentificacionEditar, setTipoIdentifiacionEditar] = useState( 0 );
    const [tipoIdentificacionEditarArray, setTipoIdentifiacionEditarArray] = useState<TipoIdentificacionProps[]>( [] );

    const [tipoParte, setTipoParte] = useState( 0 );
    const [tipoParteArray, setTipoParteArray] = useState<TipoParteProps[]>( [] );

    const [asistenteSelected, setAsistenteSelected] = useState<AsistenteProps>( defaultAsistente );

    const [documento, setDocumento] = useState( '' );
    const [openDocumento, setOpenDocumento] = useState( false );

    const { page, rowsPerPage, handleChangePage, handleChangeRowsPerPage, resetPage } = usePages(10);

    const { idPersona, nombreCompleto, idTipoPersona } = personaBusqueda;

    const seleccionarPersona = ( persona: PersonaBusquedaProps ) => setPersonaBusqueda( persona )

    const handleChangeChecked = ( value: boolean, id: number ) => {

        if ( !setAsistentes ) return;

        var newAsistentes = asistentes.map(( elem ) => {

            if ( elem.idPersona === id ) {
                elem.asistio = value;
            }

            return elem
        });

        setAsistentes( newAsistentes );
    }

    const handleAgregar = () => {

        if ( !setAsistentes ) return;

        const id = `${new Date().getUTCSeconds()}${new Date().getUTCMilliseconds()}`;

        const tipoIdentificacionFind = tipoIdentificacionArray.find( ({ idTipoIdentificacion }) => idTipoIdentificacion === tipoIdentificacion )?.descripcion ?? '';

        const baseAsistente = {
            id:     parseInt( id ) ,
            idTipoIdentificacion: tipoIdentificacion,
            tipoIdentificacion:   tipoIdentificacionFind,
        };

        if ( tipoParteAgregar === 'Otro' ) {

            const existePersona = asistentes.some( n => n.idPersona === idPersona );

            if ( existePersona ) {

                dispatch(openSnackbar({ message: 'La persona ya se encuentra agregada', variant: 'warning' }));
                return;
            }

            const tipoParteFind = tipoParteArray.find(({ idTipoParte }) => idTipoParte === tipoParte )?.descripcion ?? '';

            setAsistentes([
                ...asistentes,
                {
                    ...baseAsistente,
                    idPersona,
                    persona: nombreCompleto,
                    idTipoPersona,
                    idTipoParte: tipoParte,
                    tipoParte: tipoParteFind,
                    asistio: true,
                    notificado: false,
                    razonamiento: '',
                    cedulaNotificacion: '',
                }
            ]);

        }
        else if ( parte !== 0 ) {

            const { idPersona, persona, idTipoParte, tipoParte, idTipoPersona } = partes.find(({ id }) => id === parte ) ?? defaultParte;

            const existePersona = asistentes.some( n => n.idPersona === idPersona );

            if ( existePersona ) {

                dispatch(openSnackbar({ message: 'La persona ya se encuentra agregada', variant: 'warning' }));
                return;
            }

            setAsistentes([
                ...asistentes,
                {
                    ...baseAsistente,
                    idPersona,
                    persona: persona,
                    idTipoPersona,
                    idTipoParte: idTipoParte,
                    tipoParte: tipoParte,
                    asistio: true,
                    notificado: false,
                    razonamiento: '',
                    cedulaNotificacion: '',
                }
            ]);
        }

        setParte( 0 );
        setTipoIdentifiacion( 0 );
        setTipoParte( 0 );
        setPersonaBusqueda( defaultPersonaBusqueda );

        resetPage();
    }

    const handleEliminar = () => {

        if ( !setAsistentes ) return;

        setAsistentes( asistentes.filter( ({ id }) => id !== asistenteSelected.id ) );
        setOpenEliminar( false );
    }

    const handleEditar = () => {

        if ( !setAsistentes ) return;

        const tipoIdentificacionData = tipoIdentificacionEditarArray.find( ({ idTipoIdentificacion }) => idTipoIdentificacion === tipoIdentificacionEditar );

        var newArray = asistentes.map( ( elem ) => {

            if ( elem.id === asistenteSelected.id ) {
                elem.idTipoIdentificacion = tipoIdentificacionData?.idTipoIdentificacion ?? 0;
                elem.tipoIdentificacion = tipoIdentificacionData?.descripcion ?? '';
            }

            return elem;
        });

        setAsistentes( newArray );
        setOpenEditar( false );

    }

    const handleCheckAll = ( value : boolean ) => {

        if ( !setAsistentes ) return;

        var newAsistentes = asistentes.map(( elem ) => {
            elem.asistio = value;
            return elem
        });

        setAsistentes( newAsistentes );

    }

    const handleGuardarAsistentes = async () => {

        setLoading( true );

        await GuardarAsistentes({ idAudiencia: audiencia.idAudiencia, asistentes: asistentes }).then(resp => {

            setTimeout(() => {

                const { success, message } = resp;

                if ( success ) {

                    dispatch( openSnackbar({ message: message, variant: 'success' }) );
                    setLoading( false );

                }
                else {

                    dispatch( openSnackbar({ message: message, variant: 'error' }) );
                    setLoading( false );

                }

            }, 700);

        });

    }

    useEffect(() => {

        async function Obtener() {

            await ObtenerTipoIdentificacion().then( resp => {

                setTipoIdentifiacionArray( resp );
                setTipoIdentifiacionEditarArray( resp );

            });
        }

        Obtener();

    }, [])

    useEffect(() => {

        async function Obtener() {

            await ObtenerTipoParte().then( resp => {

                setTipoParteArray( resp );

            });

        }

        Obtener();

    }, [])

    return (
        <Box p={ 4 } component={ Paper }>

            <Grid container spacing={ 3 } mt={ 1 }>

                {
                    edit
                    &&
                        <>

                            <Grid size={{ md: 12, xs: 12 }}>

                                <FormControl>

                                    <FormLabel>Selecciona el tipo de parte que asiste a la audiencia:</FormLabel>
                                    <RadioGroup row>

                                        <FormControlLabel
                                            label='Actor/Demandado'
                                            control={ <Radio checked={ tipoParteAgregar === 'Actor/Demandado' }
                                            onChange={ () => { setTipoParteAgregar('Actor/Demandado'); setParte( 0 ); setPersonaBusqueda( defaultPersonaBusqueda ); setTipoIdentifiacion( 0 ); } }/>}
                                        />

                                        <FormControlLabel
                                            label='Otro'
                                            control={ <Radio checked={ tipoParteAgregar === 'Otro' }
                                            onChange={ () => { setTipoParteAgregar('Otro'); setParte( 0 ); setPersonaBusqueda( defaultPersonaBusqueda ); setTipoIdentifiacion( 0 ); } } />}
                                        />

                                    </RadioGroup>

                                </FormControl>

                            </Grid>

                            {
                                tipoParteAgregar === 'Actor/Demandado'
                                &&
                                    <Grid size={{ md: 12, xs: 12 }}>

                                        <FormControl required fullWidth>

                                            <InputLabel>Seleccione un asistente a la audiencia</InputLabel>

                                            <Select
                                                label='Seleccione un asistente a la audiencia'
                                                value={ parte }
                                                onChange={ (e) => { setParte( e.target.value ); setTipoIdentifiacion( 0 ); } }
                                                renderValue={( selected ) => {
                                                    if ( selected === 0 ) return 'Selecciona una opción';

                                                    const { persona } = partes.find(u => u.id === selected) ?? defaultParte;

                                                    return persona;
                                                }}
                                            >
                                                <MenuItem key={ 0 } value={ 0 }>Selecciona una opción</MenuItem>
                                                {
                                                    partes.map( ({ id, persona, tipoParte}) => (

                                                        <MenuItem key={ id } value={ id }>

                                                            <Box sx={{ display: 'flex', flexDirection: 'column' }}>

                                                                <Typography variant="body1">{ persona }</Typography>
                                                                <Typography variant="caption" color="text.secondary">
                                                                    <strong>({ tipoParte })</strong>
                                                                </Typography>

                                                            </Box>

                                                        </MenuItem>

                                                    ))
                                                }
                                            </Select>

                                        </FormControl>

                                    </Grid>
                            }

                            {
                                tipoParteAgregar === 'Otro'
                                &&
                                    <>

                                        <Grid size={{ md: 6, xs: 12 }} >

                                            <Paper component='div' sx={ InputSearchStyle } >

                                                <InputBase
                                                    sx={{ ml: 1, flex: 1 }}
                                                    inputProps={{ 'aria-label': 'Buscar persona' }}
                                                    placeholder='Buscar persona'
                                                    value={ nombreCompleto }
                                                    onChange={() => { }}
                                                    autoComplete='off'
                                                    disabled
                                                />

                                                <Button
                                                    size='small'
                                                    variant='contained'
                                                    sx={ InputSearchButtonsStyle }
                                                    onClick={ () => setOpenDialogBuscarPersona( true ) }
                                                >
                                                    <SearchIcon />
                                                </Button>

                                                <Button
                                                    variant='contained'
                                                    size='small'
                                                    sx={ InputSearchButtonsStyle }
                                                    onClick={ () => setOpenDialogNuevaPersona( true ) }
                                                >
                                                    <PersonAddIcon />
                                                </Button>

                                            </Paper>

                                        </Grid>

                                        <Grid size={{ md: 6, xs: 12 }}>

                                            <FormControl required fullWidth>

                                                <InputLabel>Tipo de parte</InputLabel>

                                                <Select
                                                    label='Tipo de parte'
                                                    value={ tipoParte }
                                                    onChange={ (e) => setTipoParte( e.target.value ) }
                                                >
                                                    <MenuItem key={ 0 } value={ 0 }>Selecciona una opción</MenuItem>

                                                    {
                                                        tipoParteArray
                                                        .map( ({ idTipoParte, descripcion }) => (
                                                            <MenuItem key={ idTipoParte } value={ idTipoParte }>{ descripcion }</MenuItem>
                                                        ))
                                                    }

                                                </Select>

                                            </FormControl>

                                        </Grid>

                                    </>
                            }

                            <Grid size={{ md: 12, xs: 12 }}>

                                <FormControl required fullWidth>

                                    <InputLabel>Tipo de identificación {partes.find( ({ idPersona }) => idPersona === parte )?.idPersona } </InputLabel>

                                    <Select
                                        label='Tipo de identificación'
                                        value={ tipoIdentificacion }
                                        onChange={ (e) => setTipoIdentifiacion( e.target.value ) }
                                        disabled={
                                            ( tipoParteAgregar === 'Actor/Demandado' && partes.find( ({ id }) => id === parte )?.idTipoPersona === 2 ) ||
                                            ( tipoParteAgregar === 'Otro' && idTipoPersona === 2 ) ||
                                            ( parte === 0 && idPersona === 0 )
                                        }
                                    >
                                        <MenuItem key={ 0 } value={ 0 }>Selecciona una opción</MenuItem>
                                        {
                                            tipoIdentificacionArray
                                            .map( ({ idTipoIdentificacion, descripcion }) => (
                                                <MenuItem key={ idTipoIdentificacion } value={ idTipoIdentificacion }>{ descripcion }</MenuItem>
                                            ))
                                        }
                                    </Select>

                                </FormControl>

                            </Grid>

                            <Grid size={{ md: 12, xs: 12 }} textAlign={ 'end' }>

                                <Button
                                    variant='contained'
                                    sx={{ width: { md: 260, xs: '100%' } }}
                                    onClick={ handleAgregar }
                                    disabled={
                                        (
                                            tipoIdentificacion === 0 &&
                                            (
                                                ( tipoParteAgregar === 'Actor/Demandado' && partes.find( ({ id }) => id === parte )?.idTipoPersona !== 2 ) ||
                                                ( tipoParteAgregar === 'Otro' && idTipoPersona !== 2 )
                                            )

                                        ) ||
                                        ( tipoParteAgregar === "Actor/Demandado" && parte === 0 ) ||
                                        ( tipoParteAgregar === "Otro" && ( ( idPersona === 0 ) || tipoParte === 0 ))
                                    }
                                >
                                    Agregar
                                </Button>

                            </Grid>

                        </>
                }

                <Grid size={{ md: 12, xs: 12 }}>

                    <TableContainer sx={{ borderRadius: 3 }}>

                        <Table>

                            <TableHead sx={{ ...TableTheadStyle }}>

                                <TableRow sx={{ borderTopLeftRadius: 10, borderTopRightRadius: 10 }}>

                                    <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '30%', fontWeight: 'bold' }}>Persona que asiste a la audiencia</TableCell>
                                    <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '20%', fontWeight: 'bold' }}>Tipo de identificación</TableCell>
                                    <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '15%', fontWeight: 'bold', textAlign: 'center' }}>Notificado</TableCell>

                                    <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '15%', fontWeight: 'bold', textAlign: 'center' }}>

                                        <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center', gap: 1.5 }}>

                                            <span>Asistió</span>
                                            {
                                                edit
                                                &&
                                                    <Tooltip title='Seleccionar todo'>
                                                        <Checkbox
                                                            checked={ asistentes.filter( ({ asistio }) => asistio === true ).length !== 0 }
                                                            disabled={ asistentes.length === 0 }
                                                            onChange={ ( e ) => handleCheckAll( e.target.checked ) }
                                                            sx={{
                                                                bgcolor: 'white',
                                                                borderRadius: 2,
                                                                padding: '5px',
                                                                ':hover': { bgcolor: 'white' }
                                                            }}
                                                        />
                                                    </Tooltip>
                                            }
                                        </Box>

                                    </TableCell>

                                    { edit && <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '20%', fontWeight: 'bold', textAlign: 'end' }}></TableCell> }

                                </TableRow>

                            </TableHead>

                            <TableBody>

                                {
                                    (
                                        rowsPerPage > 0
                                        ?
                                            asistentes.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                        :
                                            asistentes
                                    ).map(( elem, index ) => {

                                        const { idTipoIdentificacion, tipoIdentificacion, persona, tipoParte, asistio, notificado, cedulaNotificacion, razonamiento, idPersona, idTipoPersona } = elem;

                                        return <TableRow key={ index } >

                                            <TableCell>

                                                <Typography variant='subtitle1'>
                                                    <strong>{ persona }</strong>
                                                </Typography>

                                                <Typography variant='subtitle2' color='text.secondary'>
                                                    ({ tipoParte })
                                                </Typography>

                                            </TableCell>

                                            <TableCell> { tipoIdentificacion } </TableCell>

                                            <TableCell sx={{ textAlign: 'center' }}>

                                                { notificado && <CheckIcon fontSize='large' /> }

                                                <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', gap: 1, mt: notificado ? 1 : 0 }}>

                                                    {
                                                        cedulaNotificacion
                                                        &&
                                                            <Tooltip title="Cédula de notificación" placement='top'>

                                                                <IconButton
                                                                    color='primary'
                                                                    onClick={ () => { setDocumento( cedulaNotificacion ); setOpenDocumento( true ); }}
                                                                    sx={{ border: '1px solid', borderColor: 'divider', borderRadius: 1 }}
                                                                >
                                                                    <DescriptionIcon />
                                                                </IconButton>

                                                            </Tooltip>
                                                    }

                                                    {
                                                        razonamiento
                                                        &&
                                                            <Tooltip title="Razonamiento" placement='top'>

                                                                <IconButton
                                                                    color='primary'
                                                                    onClick={ () => { setDocumento( razonamiento ); setOpenDocumento( true ); } }
                                                                    sx={{ border: '1px solid', borderColor: 'divider', borderRadius: 1 }}
                                                                >
                                                                    <DescriptionIcon />
                                                                </IconButton>

                                                            </Tooltip>
                                                    }
                                                </Box>

                                            </TableCell>

                                            <TableCell sx={{ textAlign: 'center' }}>

                                                {
                                                    edit
                                                    &&
                                                        <Checkbox
                                                            checked={ asistio }
                                                            onChange={ (e) => handleChangeChecked( e.target.checked, idPersona ) }
                                                        />
                                                }

                                                { ( !edit && asistio ) && <CheckIcon fontSize='large' /> }

                                            </TableCell>

                                            {
                                                edit
                                                &&
                                                    <TableCell sx={{ textAlign: 'end' }}>

                                                        {
                                                            idTipoPersona !== 2
                                                            &&
                                                                <IconButton
                                                                    color='primary'
                                                                    onClick={ () => {
                                                                        setAsistenteSelected( elem );
                                                                        setTipoIdentifiacionEditar( idTipoIdentificacion );
                                                                        setOpenEditar( true );
                                                                    }}
                                                                >
                                                                    <EditIcon />
                                                                </IconButton>
                                                        }

                                                        <IconButton
                                                            color='primary'
                                                            onClick={ () => {
                                                                setAsistenteSelected( elem );
                                                                setOpenEliminar( true );
                                                            }}
                                                        >
                                                            <DeleteIcon />
                                                        </IconButton>

                                                    </TableCell>
                                            }

                                        </TableRow>

                                    })
                                }

                                {
                                    asistentes.length === 0
                                    &&
                                        <TableRow>

                                            <TableCell
                                                colSpan={ 7 }
                                                align="center"
                                            >
                                                <Typography variant="caption" color='secondary'> No se agregaron asistente(s) </Typography>

                                            </TableCell>

                                        </TableRow>
                                }

                            </TableBody>

                            <TableFooter>

                                <TableRow>

                                    <TableCell colSpan={ 1 }>
                                        <Typography variant='body2' color='black' sx={{ fontWeight: 'bold' }}> Total de registros: { asistentes.length } </Typography>
                                    </TableCell>

                                    <TablePagination
                                        colSpan={ 6 }
                                        rowsPerPageOptions={ [ 5, 10, 15, 25, 50, 75, 100, 150, 200, 500 ] }
                                        count={ asistentes.length }
                                        rowsPerPage={ rowsPerPage }
                                        page={ page }
                                        onPageChange={ handleChangePage }
                                        onRowsPerPageChange={ handleChangeRowsPerPage }

                                        ActionsComponent={ TablePaginationActions }

                                        labelRowsPerPage="Filas por página"
                                        labelDisplayedRows={
                                            ({ from, to, count }) => {
                                                return '' + from + '-' + to + ' de ' + count
                                            }
                                        }
                                    />

                                </TableRow>

                            </TableFooter>

                        </Table>

                    </TableContainer>

                </Grid>

                {
                    edit
                    &&
                        <Grid size={{ md: 12, xs: 12 }} sx={{ mt: 3 }}>

                            <Grid container spacing={ 3 }>

                                <Grid size={{ md: 4, xs: 12 }} sx={{ textAlign: 'right' }}> </Grid>

                                <Grid size={{ md: 4, xs: 12 }} sx={{ textAlign: 'center' }}>

                                    <Button
                                        fullWidth
                                        variant="contained"
                                        loading={ loading }
                                        onClick={ handleGuardarAsistentes }
                                    >
                                        Guardar
                                    </Button>

                                </Grid>

                                <Grid size={{ md: 4, xs: 12 }} style={{ textAlign: 'left' }}> </Grid>

                            </Grid>

                        </Grid>
                }

            </Grid>

            <Dialog
                fullWidth
                open={ openEditar }
                maxWidth='xs'
                onClose={ () => {} }
            >

                <DialogTitle>
                    Editar tipo de identificación
                </DialogTitle>

                <DialogContent>

                    <FormControl fullWidth sx={{ mt: 2 }}>
                        <InputLabel>Tipo de identificación</InputLabel>

                        <Select
                            label="Tipo de identificación"
                            value={ tipoIdentificacionEditar }
                            onChange={ (e) => setTipoIdentifiacionEditar( e.target.value ) }
                        >
                            <MenuItem value={ 0 }>Selecciona una opción</MenuItem>
                            {
                                tipoIdentificacionEditarArray
                                .map( ({ idTipoIdentificacion, descripcion }) => (
                                    <MenuItem key={ idTipoIdentificacion } value={ idTipoIdentificacion }>{ descripcion }</MenuItem>
                                ))
                            }
                        </Select>

                    </FormControl>

                </DialogContent>

                <DialogActions>

                    <Button color='secondary' onClick={ () => { setOpenEditar( false ); setTipoIdentifiacionEditar( 0 ); } }> Cancelar </Button>
                    <Button onClick={ handleEditar } variant='contained' disabled={ tipoIdentificacionEditar === 0 }> Guardar </Button>

                </DialogActions>

            </Dialog>

            <Dialog
                fullWidth
                maxWidth='xs'
                open={ openEliminar }
                onClose={ () => {} }
            >

                <DialogTitle>
                    Confirmación
                </DialogTitle>

                <DialogContent>

                    <DialogContentText>
                        ¿Desea quitar el registro seleccionado?
                    </DialogContentText>

                </DialogContent>

                <DialogActions>

                    <Button color='secondary' onClick={ () => setOpenEliminar( false ) }> Cancelar </Button>
                    <Button variant='contained' onClick={ handleEliminar }> Aceptar </Button>

                </DialogActions>

            </Dialog>

            <DialogNuevaPersona
                openDialog={ openDialogNuevaPersona }
                handleCloseDialog={ () => setOpenDialogNuevaPersona( false ) }
                seleccionarPersona={ seleccionarPersona }
            />

            <DialogBuscarPersona
                openDialog={ openDialogBuscarPersona }
                handleCloseDialog={ () => setOpenDialogBuscarPersona( false ) }
                seleccionarPersona={ seleccionarPersona }
            />

            <DialogDocumento
                openDialog={ openDocumento }
                handleCloseDialog={ () => { setOpenDocumento( false ); setDocumento( '' ); } }
                documento={ documento }
            />

        </Box>
    )
}
